// Expert Status System Types
// Activity-based expert leveling and AI visibility

export type ExpertStatusLevel = 'none' | 'verified' | 'expert' | 'top_expert';

export type ExpertStatusHealth = 'healthy' | 'warning' | 'urgent' | 'expiring';

export interface ExpertStatus {
  userId: string;
  level: ExpertStatusLevel;
  
  // Activity tracking (rolling 30 days)
  conversationsLast30Days: number;
  lastConversationDate: Date | null;
  lastLoginDate: Date;
  loginStreak: number; // Consecutive days
  
  // Health system
  health: number; // 0-100
  healthStatus: ExpertStatusHealth;
  daysUntilDowngrade: number | null;
  
  // AI Visibility
  aiVisibility: {
    enabled: boolean;
    publicProfileEnabled: boolean;
    searchRanking: number; // Higher = more visible
    lastIndexed: Date | null;
  };
  
  // Expert profile slug for public page
  slug: string | null; // e.g., "abdul-antonio"
  
  // Milestones & achievements
  totalConversations: number;
  levelAchievedAt: {
    verified: Date | null;
    expert: Date | null;
    top_expert: Date | null;
  };
  
  // Referral boost
  referralBoost: number; // Points from active referrals
  activeReferrals: number; // Number of active referred users
  
  // Timestamps
  createdAt: Date;
  updatedAt: Date;
}

export interface ExpertStatusRequirements {
  level: ExpertStatusLevel;
  conversationsRequired: number; // Last 30 days
  maxDaysSinceLogin: number;
  description: string;
}

export const EXPERT_STATUS_LEVELS: Record<ExpertStatusLevel, ExpertStatusRequirements> = {
  none: {
    level: 'none',
    conversationsRequired: 0,
    maxDaysSinceLogin: Infinity,
    description: 'Nieuwe gebruiker'
  },
  verified: {
    level: 'verified',
    conversationsRequired: 1,
    maxDaysSinceLogin: 14,
    description: 'Actief lid'
  },
  expert: {
    level: 'expert',
    conversationsRequired: 2,
    maxDaysSinceLogin: 7,
    description: 'Ervaren expert'
  },
  top_expert: {
    level: 'top_expert',
    conversationsRequired: 3,
    maxDaysSinceLogin: 5,
    description: 'Top expert'
  }
};
